import { Label } from "@/components/atoms/texts/label";
import ReadingStatus from "./readingStatus";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/molecules/popover";
import { Button } from "@/components/molecules/buttons/button";
import { useEffect, useState } from "react";
import Polygon1 from "@/assets/Polygon1.svg"
import ControlsDownload from "@/components/molecules/controlsDownload";
import getCurrencySymbolFromCode from "@/utils/getCurrencySymbolFromCode";
import { Toaster } from "@/components/organisms/feedback/toaster";
import { useDeleteExpenseReport } from "@/services/consultant-services/mutation/useDeleteExpenseReport";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import { useToast } from "@/components/organisms/feedback/use-toast";
import { useGetCompanyBenefitInvoice } from "@/services/consultant-services/api-rest/useGetCompanyBenefitInvoice";
import { useGetExpenseReportProof_AsUser } from "@/services/consultant-services/api-rest/useGetExpenseReportProof_AsUser";
import { countries, getCountryData, getCountryDataList } from "countries-list";
import { useGetExpenseReportProof_AsAdmin } from "@/services/admin-services/api-rest/useGetExpenseReportProof_AsAdmin";
import { getLabelInAppLanguage } from "@/utils/getLabelInAppLanguage";
import { Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import EditAdminModal from "@/components/macro-organisms/EditAdminModal";
import FormNewExpense from "./formNewExpense";
import ExpensePanelForReSubmit from "./expensePanelForReSubmit";
import LogoBoondManager from '@/assets/logos/logoboondmanager.svg';
import { useGenerateFiduciaryReport } from "@/services/admin-services/api-rest/useGenerateFiduciaryReport";
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import { ToastAction } from "@/components/organisms/feedback/toast";

export default function Expense({ data, dataOwner = false, refetch, editable = false, verticalView = false, hideControls = false, ...props }) {
    console.log('expense dataOwner', dataOwner);

    const [open, setOpen] = useState();
    const totalTax = data?.vatList ? data?.vatList.reduce((acc, vat) => acc + parseFloat(vat.vatAmount), 0) : 0;
    const symbol = getCurrencySymbolFromCode(data?.currency)
    const [openProof, setOpenProof] = useState(false);
    const [downloadProof, setDownloadProof] = useState(false);
    const { deleteExpenseReport, loading: loadingDelete, error: errorDelete, data: dataDelete } = useDeleteExpenseReport();
    const { getExpenseProof, loading: loadingExpenseProof, error: errorExpenseProof, data: dataExpenseProof } = dataOwner ? useGetExpenseReportProof_AsUser() : useGetExpenseReportProof_AsAdmin();
    const { generateFiduciaryReport, loading: loadingFiduciaryReport, error: errorFiduciaryReport, data: dataFiduciaryReport } = useGenerateFiduciaryReport();
    const { toast } = useToast();
    let labelLanguage = getLabelInAppLanguage();
    const [openPanelForResubmit, setOpenPanelForResubmit] = useState(false);

    const handleGetExpenseProof = () => {
        console.log("handleGetExpenseProof", data?.expenseReportFileUuid)
        if (data?.expenseReportFileUuid) {
            getExpenseProof(data?.expenseReportFileUuid);
        }
    };

    const handleOpenInvoice = () => {
        if (!dataExpenseProof) {
            handleGetExpenseProof();
        }
        dataExpenseProof && window.open(dataExpenseProof?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
    }

    const deleteExpense = (uuidExpense) => {
        console.log("deleteExpense", uuidExpense);
        deleteExpenseReport(uuidExpense);

    }

    const handleGenerateFiduciaryReport = async () => {
        console.log("generateFiduciaryReport", [data?.uuid]); // Envoi d'une liste contenant l'UUID
        if (data?.uuid) {
            const result = await generateFiduciaryReport([data?.uuid]); // Envoi sous forme de tableau
            if (result?.url) {
                const link = document.createElement("a");
                link.href = result.url;
                link.download = "FiduciaryReport.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };

    useEffect(() => {
        dataExpenseProof && window.open(dataExpenseProof?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
    }, [dataExpenseProof]);

    useEffect(() => {
        // dataFiduciaryReport && window.open(dataFiduciaryReport?.url, "_blank")// Ouvrir l'URL dans un nouvel onglet
        if (dataFiduciaryReport?.url) {
            toast({
                variant: "success",
                title: "success.fileGenerated",
                duration: 8000,
                description: "success.ifNotDownload",
                action: (
                    <ToastAction
                        altText="Si le fichier ne se télécharge pas, cliquez sur Télécharger"
                        onClick={() => {
                            const link = document.createElement("a");
                            link.href = dataFiduciaryReport?.url;
                            link.download = "FiduciaryReport.xlsx";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}
                    >
                        <Label message="global.actions.download" />
                    </ToastAction>
                ),
            })
        }
    }, [dataFiduciaryReport]);

    useEffect(() => {
        if (dataDelete?.deleteExpenseReport) {
            toast({
                variant: "success",
                title: "success.backendOperation.delete",
                duration: 8000,
                description: "La note de frais " + data?.invoiceIssuer + " " + data?.comment + " a été supprimée"
            })
            refetch(1)
        } else if (dataDelete?.deleteExpenseReport == false && errorDelete) {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorDelete?.message
            })
        }
    }, [dataDelete])

    useEffect(() => {
        const displayToast = () => {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorDelete?.message
            })
        }
        (errorDelete && !loadingDelete) && displayToast();
    }, [errorDelete]);

    useEffect(() => {
        const displayToast = () => {
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 8000,
                description: errorFiduciaryReport?.message
            })
        }
        errorFiduciaryReport && !loadingFiduciaryReport && displayToast();
    }, [errorFiduciaryReport]);

    return (
        <div className={`group bg-white w-full shadow-md px-paddingLeftAndRight py-paddingTopAndBottom rounded-sm justify-start  inline-flex gap-firstDegree lg:gap-secondDegree ${(((data?.status == "REJECTED" && dataOwner && !window.ENV.BOOND_MANAGER_ACTIVE_MODE) || !dataOwner) && !verticalView) && "hover:bg-medium hover:cursor-pointer"} ${verticalView ? "flex-col h-auto items-start " : "items-center"}`} {...props}>
            {/* <Toaster /> */}
            {/* {editable && <ExpensePanelForReSubmit openExpensePanelResubmit={openPanelForResubmit} data={data} refetchFromScratch={refetch} />} */}
            <ReadingStatus type={data?.status} adminComment={data?.adminComment} />

            {/* <div className="max-w-[15%] overflow-hidden flex gap-firstDegree">

            </div> */}

            {/* <Label fontWeight="">n°{data?.category.accountingAccountNumber}</Label> */}
            {/* //TODO passer tout les labelFr de l'app en utilisant la fonction dynamique */}
            <div className={` overflow-hidden flex gap-firstDegree  lg:flex-row items-start flex-wrap ${verticalView ? "w-full flex-row" : "grow flex-col max-w-[50%]"}`}>
                <Label className="visible text-nowrap" fontWeight="bold">{data?.category[labelLanguage]}</Label>

                <Label className=" visible text-nowrap">{data?.invoiceIssuer} </Label>
                {/* <Label className=" visible text-nowrap"> {(data?.countryCode && data?.invoiceIssuer) && `-`} </Label> */}
                <Label className=" visible text-nowrap">{countries[data?.countryCode?.toUpperCase()]?.name}</Label>



                <Label className="truncate italic">{data?.comment} </Label>

                {(data?.impactsOverflow == false && data?.status !== 'SUBMITTED') && <div className="border border-grey px-1 rounded-sm text-greyStrong italic flex items-center"><Label message="consultants.expense.impactsOverflow.falseDisplay" /></div>}
            </div>
            {/* LINK BOOND MANAGER */}
            {data?.boondManagerId && window.ENV.BOOND_MANAGER_ACTIVE_MODE && <a href={window.ENV.BOOND_MANAGER_URL + "expenses-reports/" + data?.boondManagerId} target="blank"><img src={LogoBoondManager} className="h-[24px]"></img></a>}
            {/*  ---------------- */}
            <div className={!verticalView && "hidden lg:grow"}></div>
            <div className={` ${verticalView ? "w-full" : "max-w-[45%]"} min-w-[250px] justify-end lg:min-w-[400px] overflow-hidden flex gap-firstDegree items-center ${verticalView ? "flex-col w-full items-start" : ""}`}>

                <div className={` flex-wrap flex gap-firstDegree flex-col 2xl:flex-row ${verticalView ? " w-full justify-start" : "justify-end"}`}>
                    <Label fontWeight="">{data?.invoiceDate}</Label>
                    <div className="flex gap-firstDegree shrink-0 ">
                        <Label fontWeight="semibold" message="consultants.payslip.paymentDate" />
                        <Label>{data?.paymentDate && new Date(data?.paymentDate).toLocaleDateString()}</Label>
                    </div>
                    {(data?.countryCode === "lu" || data?.countryCode === null) ?
                        <div className="flex  gap-firstDegree">
                            <Label className="" fontWeight="bold" message="consultants.expense.amountExclTaxs" />
                            <Label fontWeight="">{data?.amountExcludingVat} {symbol}</Label>
                        </div> :
                        <div className="flex  gap-firstDegree">
                            <Label className="" fontWeight="bold" message="consultants.expense.amountInclTaxs" />
                            <Label fontWeight="">{data?.totalAmount} {symbol}</Label>
                        </div>
                    }



                    {(data?.countryCode == "lu" || data?.countryCode === null) && <div className="flex  gap-firstDegree  ">
                        <Label className="" fontWeight="bold" message="consultants.expense.amountTax" />
                        {window.ENV.BOOND_MANAGER_ACTIVE_MODE ? <Label fontWeight="">{(data?.totalAmount - data?.amountExcludingVat).toFixed(2)} {symbol}</Label> : <Popover open={open} onOpenChange={setOpen} >
                            <PopoverTrigger onMouseOver={(e) => setOpen(true)} onMouseOut={(e) => setOpen(false)} asChild className="flex gap-firstDegree items-center ">
                                <div className="relative">
                                    <img src={Polygon1} className="absolute top-[-2px] left-[-6px] opacity-50" />
                                    <Label fontWeight="" className="">{totalTax.toFixed(2)} {symbol}</Label>
                                </div>

                            </PopoverTrigger>
                            <PopoverContent className="flex flex-col gap-firstDegree w-auto">

                                {data?.vatList && data?.vatList.map((vat, index) => (
                                    <div className="flex gap-firstDegree" key={index}>
                                        <Label size="body" fontWeight="bold">{vat.vatRate}% :</Label>
                                        <Label size="body">{vat?.vatAmount.toFixed(2)} {symbol}</Label>
                                    </div>
                                ))}
                            </PopoverContent>
                        </Popover>}
                    </div>}
                </div>

                <div className="flex flex-col lg:flex-row">
                    {(window.ENV.BOOND_MANAGER_ACTIVE_MODE && !dataOwner) && (loadingFiduciaryReport ? <span className="loader" /> : <Button leftIcon={<RequestQuoteRoundedIcon />} showLeftIcon showText={false} style="ghost" sizePadding="small" showToolTip className="text-night" text="consultants.expense.downloadfiduciaryReport" onClick={handleGenerateFiduciaryReport}></Button>)}

                    <ControlsDownload
                        dataOwner={dataOwner}

                        onClickNewTab={() => handleOpenInvoice()}
                        disabledOpenNewTab={!data?.expenseReportFileUuid || errorExpenseProof}
                        hideOpenNewTab={hideControls}

                        hideDownload
                        hideDelete={hideControls || data?.status == 'APPROVED' || data?.status == 'REJECTED' || window.ENV.BOOND_MANAGER_ACTIVE_MODE}
                        // hideEdit={!editable || !hasPrivileges('ADMIN_EXPENSE')}
                        hideEdit={hideControls || window.ENV.BOOND_MANAGER_ACTIVE_MODE}
                        // onClickEdit={() => setIsEditModalOpen(true)}
                        onClickDelete={() => deleteExpense(data?.uuid)}
                        disabledDelete={errorDelete}
                        titleForDelete={data?.invoiceIssuer + " - " + data?.comment}
                    />

                    {/* {isEditModalOpen && (
                        <EditAdminModal
                            data={data}
                            onClose={() => setIsEditModalOpen(false)}
                            type="expense"
                            form={
                                <FormNewExpense
                                    // onSubmit={handleSubmit}
                                    // submitRef={submitRef}
                                    data={data}
                                // isForApprovalUseCase
                                // refetchFromScratch={refetchFromScratch}
                                />
                            }
                        />
                    )} */}
                </div>

                {/* {editable && <Label>Edit</Label>} */}
                {loadingDelete || loadingExpenseProof && <span className="loader" />}
            </div>

        </div>
    )
}
